// extracted by mini-css-extract-plugin
export default {"footer":"Footer_footer__Lyk5h","areaLeft":"Footer_areaLeft__8t8yH","areaRight":"Footer_areaRight__FHdsB","copyright":"Footer_copyright__xcU-8"};